import { motion } from "framer-motion";
import {
  HardDrives,
  Cloud,
  ShieldCheck,
  Code,
  Wrench,
} from "@phosphor-icons/react";

const icons = [HardDrives, Cloud, ShieldCheck, Code, Wrench];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
  }),
};

export default function ServicesSection({ t }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32"
      style={{ background: "#050505" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-4 block font-chivo">
            {t.services.overline}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit">
            {t.services.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                custom={i}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`service-card-${i}`}
                className="group relative bg-white/[0.03] border border-white/10 rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[#00F0FF]/50 hover:shadow-[0_8px_32px_rgba(0,240,255,0.08)] hover:bg-white/[0.06]"
              >
                <div className="w-12 h-12 rounded-xl bg-[#00F0FF]/10 flex items-center justify-center mb-6 group-hover:bg-[#00F0FF]/20 transition-colors">
                  <Icon size={28} weight="duotone" className="text-[#00F0FF]" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 font-outfit">
                  {service.title}
                </h3>
                <p className="text-[#94A3B8] text-sm leading-relaxed font-chivo">
                  {service.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
